import {
  Component,
  OnInit,
  isDevMode,
  Renderer2,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { HelpersService } from '../../../../services';
import { PartnerService } from '../../../../services/partner.service';
import { AppConfig } from '../../../../app.config';

@Component({
  selector: 'app-widget-setup',
  templateUrl: './widget-setup.component.html',
  styleUrls: ['./widget-setup.component.scss'],
})
//@Pipe({ name: 'safe' })
export class WidgetSetupComponent implements OnInit, PipeTransform {
  constructor(
    private translate: TranslateService,
    private helpersService: HelpersService,
    private partnerService: PartnerService,
    private sanitizer: DomSanitizer,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private appConfig: AppConfig,
  ) {
    this.partner = this.helpersService.getPartnerData();
  }

  public partner: any;

  public tab = 0;
  public link: any;
  public shopID = '?shop=';
  public franchiseID = '?franchise=';
  public linkText = this.appConfig.getWorkshopWidgetURL() + '/bikes';
  public linkChanging: boolean = false;
  public language = 'en';
  public languages: any = [];
  public btnLinkText = this.translate.instant(
    'bikeshop.plugins.widget.copy-as-link',
  ); //'Copy as Link';
  public btnIFrameText = this.translate.instant(
    'bikeshop.plugins.widget.copy-as-iframe',
  ); //'Copy as iFrame';

  public serviceTypes: any = [];
  public serviceGroups: any = [];
  public selectedServiceTypes: any = [];
  public selectedServiceGroups: any = [];
  public disabledFeatures: any = [];

  public showPrices: boolean = true;
  public showHearAbout: boolean = true;
  public showCoupons: boolean = true;
  public showPreApprovedAmount: boolean = true;  
  public additionalInformation: string = '';
  public paymentInformation: string = '';

  public primaryColor: string = '#2b2b2b';
  public primaryTextColor: string = '#2b2b2b';
  public secondaryTextColor: string = '#2b2b2b';
  public calendarColor: string = '#000';
  public customFontName: string = 'Montserrat';
  public customFont: string =
    'https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600&display=swap';

  public widgetTrackingGTMCode: string = '';
  public widgetFacebookPixel: string = '';
  public linkedToFranchise: boolean = false;
  public hasFittings: boolean = false;
  public hasCollectionsOrDropOffs : boolean = false;

  public showPreviewWidgetPanel: boolean = false;

  public requireItemOnFitting: boolean = true;
  public onFittingTab: boolean = false;
  public defaultFittingItemName: string = 'Item';
  public workshopWidgetNextServiceBufferTime : number = 1;
  public usesFranchiseTheme : boolean = false;

  public fontOptions = [
    {
      value: 'Roboto',
      url: 'https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;600&display=swap',
    },
    {
      value: 'Lato',
      url: 'https://fonts.googleapis.com/css2?family=Lato:wght@400;500;600&display=swap',
    },
    {
      value: 'Lora',
      url: 'https://fonts.googleapis.com/css2?family=Lora:wght@400;500;600&display=swap',
    },
    {
      value: 'Inter',
      url: 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap',
    },
    {
      value: 'Encode Sans',
      url: 'https://fonts.googleapis.com/css2?family=Encode+Sans:wght@400;500;600&display=swap',
    },
    {
      value: 'Manrope',
      url: 'https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600&display=swap',
    },
    {
      value: 'Raleway',
      url: 'https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;600&display=swap',
    },
    {
      value: 'Oswald',
      url: 'https://fonts.googleapis.com/css2?family=Oswald:wght@400;500;600&display=swap',
    },
    {
      value: 'Montserrat',
      url: 'https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600&display=swap',
    },
    {
      value: 'Poppins',
      url: 'https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap',
    },
    {
      value: 'Work Sans',
      url: 'https://fonts.googleapis.com/css2?family=Work+Sans:wght@400;500;600&display=swap',
    },
    {
      value: 'Archivo',
      url: 'https://fonts.googleapis.com/css2?family=Archivo:wght@400;500;600&display=swap',
    },
    {
      value: 'Merriweather',
      url: 'https://fonts.googleapis.com/css2?family=Merriweather:wght@400;500;600&display=swap',
    },
    {
      value: 'Open Sans',
      url: 'https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;500;600&display=swap',
    },
    {
      value: 'Source Sans Pro',
      url: 'https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@400;500;600&display=swap',
    },
    { value: 'Arial', url: 'Built-In' },
    { value: 'Comic Sans MS', url: 'Built-In' },
    { value: 'Lucida', url: 'Built-In' },
    { value: 'Tahoma', url: 'Built-In' },
    { value: 'Times New Roman', url: 'Built-In' },
    { value: 'Trebuchet MS', url: 'Built-In' },
    { value: 'Verdana', url: 'Built-In' },
  ].sort((x, y) => {
    if (x.value > y.value) return 1;
    if (x.value < y.value) return -1;
    return 0;
  });

  public saving: boolean = false;

  public modules = {
    toolbar: [
      ['bold', 'italic', 'underline'], // toggled buttons
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link'], // outdent/indent
      [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
      ['clean'], // remove formatting button
    ],
  };

  @ViewChild('additionalInfoEditor') quillEditor: ElementRef;
  @ViewChild('paymentInfoEditor') quillEditor_PaymentInfo: ElementRef;

  ngOnInit() {

    if (this.partner.ExternalKey == null) {
      this.linkChanging = true;
      this.partnerService
        .getPartnerDetail(this.helpersService.getPartnerId())
        .subscribe((resp) => {
          console.log(resp);
          this.partner.ExternalKey = resp.ExternalKey;
          this.helpersService.savePartnerData(this.partner);
          this.shopID += this.partner.ExternalKey;
          this.link = this.transform(this.linkText + this.shopID + lang);
          this.linkChanging = false;
        });
    } else {
      this.shopID += this.partner.ExternalKey;
      this.partnerService
        .getPartnerWidgetSettings(this.partner.ExternalKey)
        .subscribe((reply: any) => {
          console.log(reply);
          var obj = JSON.parse(reply);
          console.log(obj);
          for (var i = 0; i < obj.settings.length; i++) {
            this.showCoupons = obj.settings[i].AllowCoupons;
            this.showHearAbout = obj.settings[i].ShowHearAboutQuestion;
            this.showPreApprovedAmount = obj.settings[i].ShowPreApprovedAmount;
            this.showPrices = obj.settings[i].ShowPrices;
            this.additionalInformation = obj.settings[i].AdditionalInformation;
            this.paymentInformation = obj.settings[i].PaymentInformation;
            this.linkedToFranchise = obj.settings[i].FranchiseID && true;
            if(this.linkedToFranchise){
              this.franchiseID += obj.settings[i].FranchiseID
            }
            if (obj.settings[i].PrimaryColor) {
              this.primaryColor = obj.settings[i].PrimaryColor;
            }

            if (obj.settings[i].PrimaryTextColor) {
              this.primaryTextColor = obj.settings[i].PrimaryTextColor;
            }

            if (obj.settings[i].SecondaryTextColor) {
              this.secondaryTextColor = obj.settings[i].SecondaryTextColor;
            }

            if (obj.settings[i].CalendarColor) {
              this.calendarColor = obj.settings[i].CalendarColor;
            }

            if (obj.settings[i].CustomFontName) {
              this.customFontName = obj.settings[i].CustomFontName;
            }

            this.widgetTrackingGTMCode = obj.settings[i].WidgetTrackingGTMCode;
            this.widgetFacebookPixel = obj.settings[i].WidgetFacebookPixel;
            this.workshopWidgetNextServiceBufferTime = obj.settings[i].WorkshopWidgetNextServiceBufferTime ? obj.settings[i].WorkshopWidgetNextServiceBufferTime : 1;
            this.usesFranchiseTheme = obj.settings[i].UsesFranchiseTheme ? obj.settings[i].UsesFranchiseTheme : false;
          }
        });
    }

    var partner = this.helpersService.getPartnerData();
    if(partner.OffersCollections || partner.OffersDropOffs){
      this.hasCollectionsOrDropOffs = true;
    }
      

    this.link = this.transform(this.linkText);
    this.languages.push({ label: 'Chinese (Simplified)', value: 'zh-chs' });
    this.languages.push({ label: 'Chinese (Traditional)', value: 'zh-cht' });
    this.languages.push({ label: 'Chinese (Taiwan)', value: 'zh-tw' });
    this.languages.push({ label: 'English', value: 'en' });
    this.languages.push({ label: 'English US', value: 'en-us' });
    this.languages.push({ label: 'Dutch', value: 'nl' });
    this.languages.push({ label: 'Deutsch', value: 'de' });
    this.languages.push({ label: 'Español', value: 'es' });
    this.languages.push({ label: 'Française', value: 'fr' });
    this.languages.push({ label: 'Hungarian', value: 'hu' });
    this.languages.push({ label: 'Italiano', value: 'it' });
    this.languages.push({ label: 'Japanese', value: 'ja' });
    this.languages.push({ label: 'Korean', value: 'ko' });
    this.languages.push({ label: 'Norwegian', value: 'nb' });
    this.languages.push({ label: 'Polskie', value: 'pl' });
    this.languages.push({ label: 'Finnish', value: 'fi' });
    this.languages.push({ label: 'Swedish', value: 'sv' });        
    
    var lang = this.language.length > 0 ? '&lang=' + this.language : 'en';
    this.link = this.transform(this.linkText + this.shopID + lang);

    this.getServiceTypes();
  }

  onQuillEditorCreated(editor) {
    editor.root.addEventListener('blur', () => {
      //this.updateURL();
    });
  }

  changeTab(tab) {
    this.selectedServiceTypes = [];
    this.selectedServiceGroups = [];
    this.disabledFeatures = [];

    // this.showPrices = true;
    // this.showHearAbout = true;
    // this.showCoupons = true;

    this.tab = tab;
    this.onFittingTab = false;
    var lang = this.language.length > 0 ? '&lang=' + this.language : 'en';
    if (tab == 0) {
      this.linkText = this.appConfig.getWorkshopWidgetURL() + '/bikes';
    }
    if (tab == 1) {
      this.linkText = this.appConfig.getWorkshopWidgetURL() + '/fittings';
      this.onFittingTab = true;
    }
    if (tab == 2) {
      this.linkText = this.appConfig.getWorkshopWidgetURL() + '/collections';
    }
    this.link = this.transform(this.linkText + this.shopID + lang);

    //Handle Multistore Widget 
    if (tab == 3) {
      this.linkText = this.appConfig.getWorkshopWidgetURL() + '/bikes';
      this.link = this.transform(this.linkText + this.franchiseID + lang);
    }
    if (tab == 4) {
      this.linkText = this.appConfig.getWorkshopWidgetURL() + '/fittings';
      this.link = this.transform(this.linkText + this.franchiseID + lang);
    }

    
  }

  transform(url) {
    console.log(this.sanitizer.bypassSecurityTrustResourceUrl(url).toString());
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  // languageChanged() {
  //   var lang = this.language.length > 0 ? "&lang=" + this.language : "en";
  //   this.setURL();
  // }

  // updateURL() {
  //   //console.log(this.selectedServiceTypes);
  //   this.setURL();
  // }

  // setURL() {

  //   //const myUrlWithParams = new URL(this.linkText);

  //   //myUrlWithParams.searchParams.append("shop", this.partner.ExternalKey);
  //   //myUrlWithParams.searchParams.append("lang", this.language);
  //   //if (this.selectedServiceTypes.length > 0)
  //   //myUrlWithParams.searchParams.append("service", this.selectedServiceTypes.join(","));

  //   //console.log(myUrlWithParams.href.toString());

  //   this.partnerService.savePartnerWidgetSettings(this.partner.ExternalKey, {
  //     "ShowPrices": this.showPrices,
  //     "ShowHearAboutQuestion": this.showHearAbout,
  //     "AllowCoupons": this.showCoupons,
  //     "ShowPreApprovedAmount": this.showPreApprovedAmount,
  //     "AdditionalInformation": this.additionalInformation,
  //   }
  //   ).subscribe(resp => {
  //     var lang = this.getURL();

  //     this.link = this.transform(this.linkText + this.shopID + lang);

  //     setTimeout(() => {
  //       this.linkChanging = false;
  //     }, 500);
  //   })
  // }

  getServiceTypes() {
    this.serviceTypes = [];
    this.serviceGroups = [];

    this.partnerService
      .getPartnerServiceTypesDropDowns(this.partner.ID)
      .subscribe((serviceTypes) => {
        
        this.hasFittings = serviceTypes.filter((serviceType) => {return serviceType.IsActive && serviceType.IsFitting}).length > 0;

        var GroupName = '';
        serviceTypes
          .filter((serviceType) => {
            return serviceType.IsActive;
          })
          .sort((x, y) => {
            return x.GroupOrder - y.GroupOrder || x.GroupName - y.GroupName;
          })
          .map((serviceType) => {
            serviceType.GroupName = serviceType.GroupName
              ? serviceType.GroupName
              : this.translate.instant('general.not_grouped');
            if (serviceType.GroupName !== GroupName) {
              GroupName = serviceType.GroupName;
              this.serviceTypes.push({
                label: serviceType.GroupName,
                value: -1,
                disabled: true,
                search: '',
                reverseSearch: '',
              });

              var groupFound = false;
              for (var i = 0; i < this.serviceGroups.length; i++) {
                if (this.serviceGroups[i].label == serviceType.GroupName)
                  groupFound = true;
              }
              if (!groupFound)
                this.serviceGroups.push({
                  label: serviceType.GroupName,
                  value: serviceType.GroupName,
                  disabled: false,
                  search: '',
                  reverseSearch: '',
                });
            }
            var words = serviceType.ServiceTypeDescription.split(' ');
            var reverseSearch = [];
            if (words) {
              words.forEach((word) => {
                reverseSearch.unshift(word);
              });
            }
            this.serviceTypes.push({
              label:
                serviceType.ServiceTypeDescription +
                ' - ' +
                this.helpersService.getPartnerData().CurrencySymbol +
                serviceType.Cost,
              value: serviceType.ID,
              hours: serviceType.Hours,
              cost: serviceType.Cost,
              search: serviceType.ServiceTypeDescription,
              reverseSearch: reverseSearch.join(' '),
            });
          });
      });
  }

  copyLink() {
    var lang = this.getURL();

    //this.clipboard.copy(this.linkText);
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    if(this.tab === 3){
      selBox.value = this.linkText + this.franchiseID + lang;
    }else{
      selBox.value = this.linkText + this.shopID + lang;
    }
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.btnLinkText = this.translate.instant('bikeshop.plugins.widget.copied');

    setTimeout(() => {
      this.btnLinkText = this.translate.instant(
        'bikeshop.plugins.widget.copy-as-link',
      );
    }, 500);
  }

  copyIFrame() {
    var lang = this.getURL();

    var iframe =
      '<iframe src="' +
      this.linkText +
      (this.tab === 3 ? this.franchiseID : this.shopID) +
      lang +
      '" frameborder="0" allow="geolocation" style="width: 100%; height: 825px;"></iframe>';
    //var iframe = '<iframe src="' + this.link + '" frameborder="0" allow="geolocation" style="width: 100%; height: 825px;"></iframe>'
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = iframe;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.btnIFrameText = this.translate.instant(
      'bikeshop.plugins.widget.copied',
    );
    setTimeout(() => {
      this.btnIFrameText = this.translate.instant(
        'bikeshop.plugins.widget.copy-as-iframe',
      );
    }, 500);
  }

  getURL() {
    this.disabledFeatures = [];

    var lang = this.language.length > 0 ? '&lang=' + this.language : 'en';
    if (this.selectedServiceTypes.length > 0 && this.tab < 3)
      lang += '&service=' + this.selectedServiceTypes.join(',');
    if (this.selectedServiceTypes.length > 0 && this.tab >= 3)
      lang += '&serviceTypes=' + encodeURIComponent(this.selectedServiceTypes.join(','));
    if (this.selectedServiceGroups.length > 0)
      lang += '&groups=' + this.selectedServiceGroups.join('|');
    //if (!this.showPrices)
    //  this.disabledFeatures.push('prices')
    //if (!this.showHearAbout)
    //  this.disabledFeatures.push('hearabout')
    //if (!this.showCoupons)
    //  this.disabledFeatures.push('coupons')
    //if (this.disabledFeatures.length > 0)
    //  lang += "&disabled=" + this.disabledFeatures.join(",");
    lang += isDevMode() ? '&dev=true' : '';
    return lang;
  }

  updateColor(event, field) {
    switch (field) {
      case 'primaryColor':
        this.primaryColor = event;
        break;
      case 'primaryTextColor':
        this.primaryTextColor = event;
        break;
      case 'secondaryTextColor':
        this.secondaryTextColor = event;
        break;
      case 'calendarColor':
        this.calendarColor = event;
        break;
    }
  }

  updateFont(event) {
    this.customFont = event.url;
    this.customFontName = event.value;
  }

  saveConfig(showPreview) {
    var data = {
      ShowPrices: this.showPrices,
      ShowHearAboutQuestion: this.showHearAbout,
      AllowCoupons: this.showCoupons,
      ShowPreApprovedAmount: this.showPreApprovedAmount,
      AdditionalInformation: this.additionalInformation,
      PaymentInformation: this.paymentInformation,
      PrimaryColor: this.primaryColor,
      PrimaryTextColor: this.primaryTextColor,
      SecondaryTextColor: this.secondaryTextColor,
      CalendarColor: this.calendarColor,
      CustomFont: this.customFont,
      CustomFontName: this.customFontName,
      WidgetTrackingGTMCode: this.widgetTrackingGTMCode,
      WidgetFacebookPixel: this.widgetFacebookPixel,
      RequireItemOnFitting: this.requireItemOnFitting,
      DefaultFittingItemName: this.defaultFittingItemName,
      WorkshopWidgetNextServiceBufferTime: this.workshopWidgetNextServiceBufferTime
    };

    this.saving = true;

    this.partnerService
      .savePartnerWidgetSettings(this.partner.ExternalKey, data)
      .subscribe(
        (resp) => {
          var lang = this.getURL();

          this.link = this.transform(this.linkText + this.shopID + lang);

          setTimeout(() => {
            this.linkChanging = false;
          }, 500);

          this.saving = false;

          if (showPreview) {
            this.showWidgetPreview();
          }
        },
        (err) => {
          this.saving = false;
        },
      );
  }

  showWidgetPreview() {
    var lang = this.getURL();
    if(this.tab >= 3){
      this.link = this.transform(this.linkText + this.franchiseID + lang);
    }else{
      this.link = this.transform(this.linkText + this.shopID + lang);
    }
    this.showPreviewWidgetPanel = true;
  }

  validateBufferTime(value: number) {
    if (value < 1) {
      this.workshopWidgetNextServiceBufferTime = 1;
    }
  }

  isConfigValid(): boolean {
    return this.workshopWidgetNextServiceBufferTime >= 1;
  }
}
